<template>
    <card title="projects" v-loading="loading.teamProjects">
        <Table :items="teamProjects" :columns="columns" :links="links" filterProp="name" />
    </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/components/Card';
import Table from '@/components/Table';

export default {
    data() {
        return {
            columns: [
                {label: 'Name', prop: 'name'},
                {label: 'Slug', prop: 'slug'},
                {label: 'Status', formatter: item => item.is_deleted ? 'Deleted' : 'Active'},
            ],
            links: [{ label: 'View project', to: item => `/customers/project/${item.id}` }]
        };
    },
    components: {
        Card,
        Table,
    },
    computed: mapGetters(['loading', 'teamProjects']),
}
</script>

<style scoped>

</style>